import React from 'react';
import {NotificationContext} from 'context';

export function useNotificationBar() {
	return React.useContext(NotificationContext);
}
